export default "__VITE_ASSET__CFx80hbf__"